import { useSetFilter } from '../../filter';
import { AddOnOrderKey } from '../domain';

export const useSetAddOnListOrder = () => {
  return useSetFilter(AddOnOrderKey, 'addOnOrderBy', true);
};
